import {Link, withRouter} from 'react-router-dom';
import * as React from "react";
import {useEffect, useState} from "react";
import {Col, Container, Dropdown, Nav, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faSearch, faUser, faShoppingBasket} from '@fortawesome/free-solid-svg-icons'
import {Avatar} from "antd";
import DropdownMenu from "./DropdownMenu";
import {setMenuData} from "../../services/redux/actions/GeneralAction";
import {setRightBasketModal} from "../../services/redux/actions/BasketAction";
import {connect, useSelector} from 'react-redux'
import UserInfo from "../auth/UserInfo";
import BasketInfo from '../pages/Consumer/basket/BasketInfo'
import Search from "./Search";
import {reduxStore} from "../../services/redux/ReduxIndex";

const Header = (props) => {
    const userInfo = UserInfo.info();
    const selector = useSelector(state => state);
    const [width, setWidth] = useState(window.innerWidth);
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const {basketList} = reduxStore.getState().BasketReducer;
    const currentBasketList = useSelector(state => state.BasketReducer.basketList);

    let menuData = userInfo.user_roles_id === 3 ?
        selector?.GeneralReducer?.menuData?.lists.filter(data => !data.id.includes('archive')) :
        selector?.GeneralReducer?.menuData?.lists.filter(data => (!data.id.includes('shiniq_world') && !data.id.includes('authorized_pharmacies')));

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    return (
        <>
            <header className={'header'}>
                <Container className={'header-container'}>
                    <Row className={'header-row'}>
                        <Col xs={'auto'}>
                            <div className={'logo-div'}>
                                <Link to={'/anasayfa'}>
                                    <img
                                        className={userInfo?.user_roles_id === 3 ? 'orzax-shiniq consumer' : 'orzax-shiniq'}
                                        src={require('../../assets/images/png/theme/SHINIQ_Logo.png')}
                                        alt={'orzax-shiniq'}
                                    />
                                </Link>
                            </div>
                        </Col>
                        {
                            UserInfo.info() && (
                                <>
                                    {
                                        width > 1199 && (
                                            <Col xs={true} className={'my-auto h-100'}>
                                                <div className={'menu top-menu h-100 d-flex align-items-center justify-content-end'}>
                                                    <DropdownMenu config={menuData} className={'menu top-menu h-100'}/>
                                                </div>
                                            </Col>
                                        )
                                    }
                                    {
                                        width > 991 && (
                                            <Col xs={true} xl={'auto'} className={'my-auto'}>
                                                <div className={'d-flex justify-content-end w-100'}>
                                                    <Search/>
                                                </div>
                                            </Col>
                                        )
                                    }
                                    <Col xs={true} lg={'auto'} className={'my-auto h-100'}>
                                        <div className={'user-container'}>
                                            <Container>
                                                <Row className={'justify-content-end'}>
                                                    <Col xs={'auto'} className={'my-auto ps-0 pe-0'}>
                                                        <Nav className="nav navbar-header navbar-profile">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="success" id="profile-basic">
                                                                    <FontAwesomeIcon icon={faUser}/>
                                                                    {
                                                                        width > 767 && (
                                                                            <span>{UserInfo.info('first_name')}</span>
                                                                        )
                                                                    }
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item as={'div'} className={'profile'}>
                                                                        <div className={'image'}>
                                                                            <Avatar size={72}>{UserInfo.shortName()}</Avatar>
                                                                            <span className={'name'}>{UserInfo.fullUserName()}</span>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item as={Link} to={'/hesabim/bilgilerim'}>
                                                                        HESAP BİLGİLERİ
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item as={Link} to={'/hesabim/sifre'}>
                                                                        ŞİFRE DEĞİŞİKLİĞİ
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item as={Link} to={'/hesabim/iletisim-tercihlerim'}>
                                                                        İLETİŞİM TERCİHLERİ
                                                                    </Dropdown.Item>
                                                                    {
                                                                        userInfo && userInfo.user_roles_id === 3 ? (
                                                                            <>
                                                                                <Dropdown.Item as={Link} to={'/hesabim/siparislerim'}>SİPARİŞLERİM</Dropdown.Item>
                                                                                {/*  <Dropdown.Item as={Link} to={'/my-account/earn-points'}>Doldur Kazan</Dropdown.Item>*/}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {
                                                                                    userInfo.user_roles_id === 4 && (
                                                                                        <Dropdown.Item as={Link} to={'/hesabim/eczane-yetkilileri'}>
                                                                                            ECZANE YETKİLİLERİ
                                                                                        </Dropdown.Item>
                                                                                    )
                                                                                }

                                                                                {/*<Dropdown.Item as={Link} to={'/hesabim/score'}>*/}
                                                                                {/*    Puan Yönetimi*/}
                                                                                {/*</Dropdown.Item>*/}
                                                                                {/*<Dropdown.Item as={Link} to={'/hesabim/coupon'}>*/}
                                                                                {/*    Kupon Yönetimi*/}
                                                                                {/*</Dropdown.Item>*/}
                                                                            </>
                                                                        )
                                                                    }
                                                                    <Dropdown.Item href={'#'} onClick={() => UserInfo.logout(props)}>
                                                                        GÜVENLİ ÇIKIŞ
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                            {
                                                                userInfo && userInfo.user_roles_id === 3 && (
                                                                    <Dropdown className={'dropdown-basket'}>
                                                                        <Dropdown.Toggle
                                                                            variant="success"
                                                                            onClick={() => setRightBasketModal(true)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faShoppingBasket}/>
                                                                            <span>({currentBasketList?.products ? currentBasketList?.products?.length : 0})</span>
                                                                        </Dropdown.Toggle>
                                                                    </Dropdown>
                                                                )
                                                            }
                                                        </Nav>
                                                    </Col>
                                                    {
                                                        width < 992 && (
                                                            <Col xs={'auto'} className={'my-auto d-lg-none-custom mobile-search'}>
                                                                <button
                                                                    className={'p-0'}
                                                                    onClick={() => setShowMobileSearch(!showMobileSearch)}>
                                                                    <FontAwesomeIcon icon={faSearch}/>
                                                                </button>
                                                            </Col>
                                                        )
                                                    }
                                                    <Col xs={'auto'} className={'my-auto d-lg-none-custom ps-0 pe-0'}>
                                                        <div
                                                            className={'left-menu-button'}
                                                            onClick={() => setMenuData({leftMenuVisible: true})}
                                                        >
                                                            <FontAwesomeIcon icon={faBars}/>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </Col>
                                </>
                            )
                        }
                        <Col xs={'auto'} style={{paddingLeft: '0'}}>
                            <div className={'logo-div'}>
                                <Link to={'/anasayfa'}>
                                    <img
                                        className={userInfo?.user_roles_id === 3 ? 'orzax-club consumer' : 'orzax-club'}
                                        src={require('../../assets/images/png/theme/orzax-club-logo-2.png')}
                                        alt={'orzax-club'}
                                    />
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
            {
                showMobileSearch && width < 992 && (
                    <div className={'search-bar'}>
                        <Search/>
                    </div>
                )
            }
            {
                showMobileSearch && width < 992 && (
                    <div className={'mobile-search-backdrop'} onClick={() => setShowMobileSearch(false)}/>
                )
            }
        </>
    );
}

export default withRouter(Header);

